<script>
import appConfig from '@src/app.config.json'
import FigmentResearchLayout from '@layouts/figment-research.vue'
import Tabs from '@components/tabs/tabs.vue'
import AppStream from '@components/app-stream/app-stream.vue'
import { httpServices } from '@utils/http-services'
import store from '@state/store'

const oneHourAgo = (d) => {
  const now = new Date().getTime()
  const hour = 1000 * 60 * 30
  const hourAgo = now - hour
  return d > hourAgo
}

export default {
  page: {
    title: 'Figment Research',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { FigmentResearchLayout, Tabs, AppStream },
  data() {
    return {
      figment: {},
      containers: [],
    }
  },
  mounted() {
    this.getFigment()
      .then(() => {
        store.commit('figments/SET_FIGMENT', this.figment)
      })
      .then(() => {
        this.getContainers()
      })
  },
  methods: {
    async getFigment() {
      const figment = await httpServices.getFigment(
        this.$route.params.figmentId
      )
      this.figment = figment
      await this.lastAccessFigment(figment)
    },
    async getContainers() {
      const containers = await httpServices.getContainers()
      const fleetStatus = await httpServices.getFleetStatus()
      if (this?.figment?.meta?.containers?.length) {
        this.containers = containers.filter((c) =>
          this.figment.meta.containers.includes(c?.meta?.bonfireId)
        )
        this.containers.sort((a, b) => (a.name > b.name ? 1 : -1))
      } else {
        this.containers = []
      }

      this.containers.forEach((c) => {
        const state = fleetStatus?.filter((f) => f?.bonfireId === c?.bonfireId)
        c.state = state[0]?.State
      })
    },
    async lastAccessFigment(figment) {
      if (figment?.meta?.lastAccessed && figment?.meta?.lastAccessedBy) {
        if (figment.meta.lastAccessedBy !== this.$auth.user.email) {
          const accessInLastHour = oneHourAgo(figment.meta.lastAccessed)
          if (accessInLastHour) {
            if (figment?.meta?.currentUsers?.length) {
              if (
                figment.meta.currentUsers.indexOf(this.$auth.user.email) === -1
              ) {
                figment.meta.currentUsers.push(this.$auth.user.email)
              }
            } else {
              figment.meta.currentUsers = [this.$auth.user.email]
            }
            this.$notification.warning({
              message: `Another user is currently accessing this figment`,
            })
          } else {
            figment.meta.currentUsers = [this.$auth.user.email]
          }
        } else {
          figment.meta.currentUsers = [this.$auth.user.email]
        }
      }
      figment.meta.lastAccessed = new Date().getTime()
      figment.meta.lastAccessedBy = this.$auth.user.email
      await httpServices.updateFigment(figment)
    },
  },
}
</script>

<template>
  <FigmentResearchLayout
    v-if="figment"
    :containers="containers"
    :figment="figment"
  >
    <div id="personas--container" class="ant-row">
      <div id="tabs--container" class="ant-col-8">
        <Tabs />
      </div>
      <div id="app-stream--container" class="ant-col-16">
        <AppStream />
      </div>
    </div>
  </FigmentResearchLayout>
</template>
